import { Box, Grid, Typography } from '@mui/material';
import styles from './Others.module.scss';
import { useNavigate, useNavigation } from 'react-router-dom';
import { HcccCard } from '../common/StyledComponents/StyledFields';

const Others = (): JSX.Element => {
   const navigation = useNavigate();

   const handleCardClick = () => {
      navigation('/bhajana');
   }
   const voulnterRegClick = () => {
   navigation('/volunteer')
   };
   const hadnleFaqClick = ()=>{
      navigation('/faqs')
   }
   const handleAbouttemple =()=>{
      navigation('/abouttemple')
   }
   return (
      <Grid className={styles.entireLayout}>
         <Typography
          className={styles.headerName}
         >
            Temple Essentials
         </Typography>
         <Grid className={styles.totalLayout} >
        
            <Grid className={styles.singleLayout} onClick={voulnterRegClick}>
               <img src={"/images/Volunteer_registration.jpg"} className={styles.image} />
               <Typography className={styles.titleStyles}>Volunteer Registration</Typography>
            </Grid>
            <Grid className={styles.singleLayout} onClick={handleCardClick}>
               <img src={"/images/Sahana_prayer.jpg"} className={styles.image}/>
               <Typography className={styles.titleStyles}>Prayers/Bhajans/Slokas</Typography>
            </Grid>
            <Grid className={styles.singleLayout} onClick={handleAbouttemple}>
               <img src={"/images/About_temple.jpg"} className={styles.image}/>
               <Typography className={styles.titleStyles} >About Temple</Typography>
            </Grid>
            <Grid className={styles.singleLayout} onClick={hadnleFaqClick}>
               <img src={"/images/FAQ.jpg"} className={styles.image}/>
               <Typography className={styles.titleStyles}>FAQ</Typography>
            </Grid>
         </Grid>
      </Grid>
   );
};

export default Others;
